<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'VueRulerTool',
})
</script>
<template>
  <div ref="el" v-show="rulerToggle" id="rulerTool" :style="{width : windowWidth + 'px',height : windowHeight + 'px',position:props.position}" class="ScaleBox" @onselectstart="e=>{return false}">
   <div id="levelRuler" ref="levelRuler" class="ScaleRuler_h" @mousedown.stop="levelDragRuler">
      <span v-for="(item,index) in xScale" :key="index" :style="{left:(index * 50 + 2) + 'px'}" class="n">{{ item.id }}</span>
    </div>
    <div id="verticalRuler" ref="verticalRuler" class="ScaleRuler_v" @mousedown.stop="verticalDragRuler">
      <span v-for="(item,index) in yScale" :key="index" :style="{top:(index * 50 + 2 )+ 'px'}" class="n">{{ item.id }}</span>
    </div>
    <div id="levelDottedLine" ref="levelDottedLine" :style="{top:verticalDottedTop + 'px'}" class="RefDot_h"></div>
    <div id="verticalDottedLine" ref="verticalDottedLine" :style="{left:levelDottedLeft + 'px'}" class="RefDot_v"></div>
    <div v-for="item in levelLineList" :id="item.id" :title="item.title" :style="{top:item.top+ 'px'}" :key="item.id" class="RefLine_h" @mousedown="dragLevelLine(item.id)"></div>
    <div v-for="item in verticalLineList" :id="item.id" :title="item.title" :style="{left:item.left+ 'px'}" :key="item.id" class="RefLine_v" @mousedown="dragVerticalLine(item.id)"></div>
    <div ref="content" id="content" :style="{left: props.contentLayout.left + 'px',top: props.contentLayout.top + 'px'}" style="padding: 18px;">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts" name="VueRulerTool">
import { Console } from 'console'
import { DefineProps,ref,onMounted, onBeforeUnmount } from 'vue'
const content=ref()
const levelRuler=ref()
const verticalRuler=ref()
const levelDottedLine=ref()
const verticalDottedLine=ref()
const el=ref()


const props=defineProps({
    position: {
      type: String,
      default: 'relative',
      validator(val) {
        return ['absolute', 'fixed', 'relative', 'static', 'inherit'].indexOf(val) !== -1
      }
    }, // 规定元素的定位类型
    isHotKey: {
      type: Boolean, default: true
    }, // 热键开关
    isScaleRevise: {
      type: Boolean, default: false
    }, // 刻度修正(根据content进行刻度重置)
    presetLine: {
      type: Array,
      default(){
        return [] // { type: 'l', site: 50 }, { type: 'v', site: 180 }
      }
    }, // 预置参考线
    contentLayout: {
      type: Object,
      default: () => {
        return { top: 0, left: 0 }
      }
    }, // 内容部分布局
    parent: {
      type: Boolean,
      default: false
    }
  })
const windowWidth=ref<number>(0)// 水平刻度
const windowHeight=ref<number>(0)// 垂直刻度
const rulerToggle=ref<boolean>(true)
const verticalLineList=ref<Array>([])// 生成的垂直线列表
const levelDottedLeft=ref<number>(-999)// 水平虚线位置
const verticalDottedTop=ref<number>(-999)// 垂直虚线位置
const levelLineList=ref<Array>([])// 生成的水平线列表
const xScale=ref<Array>([])
const yScale=ref<Array>([])

var   topSpacing= 0, // 标尺与窗口上间距
      leftSpacing= 0, //  标尺与窗口左间距
      isDrag= false,
      dragFlag= '', // 拖动开始标记，可能值x(从水平标尺开始拖动),y(从垂直标尺开始拖动)
      rulerWidth= 0, // 垂直标尺的宽度
      rulerHeight= 0, // 水平标尺的高度
      dragLineId= '', // 被移动线的ID
      keyCode= {
        r: 82
      } // 快捷键参数

function init() {
      box()
      scaleCalc()
    }
function box() {
      if (props.isScaleRevise) { // 根据内容部分进行刻度修正

        const content = document.getElementById('content')
        if(!content){
          setTimeout(box,1000)
          return false
        }
        const contentLeft = content.offsetLeft
        const contentTop = content.offsetTop

        for (let i = 0; i < contentLeft; i += 1) {
          if (i % 50 === 0 && i + 50 <= contentLeft) {
            xScale.value.push({ id: i })
          }
        }
        for (let i = 0; i < contentTop; i += 1) {
          if (i % 50 === 0 && i + 50 <= contentTop) {
            yScale.value.push({ id: i })
          }
        }
      }
      if(props.parent){
        const style = window.getComputedStyle(el.value.parentNode,null)

        windowWidth.value = parseInt(style.getPropertyValue('width'), 10)
        windowHeight.value = parseInt(style.getPropertyValue('height'), 10)
      }else {
        windowWidth.value = document.documentElement.clientWidth - leftSpacing
        windowHeight.value = document.documentElement.clientHeight - topSpacing
      }
      rulerWidth = verticalRuler.value.clientWidth
      rulerHeight = levelRuler.value.clientHeight
      topSpacing =levelRuler.value.getBoundingClientRect().y
      leftSpacing =verticalRuler.value.getBoundingClientRect().x
    } // 获取窗口宽与高
function  scaleCalc() {
      for (let i = 0; i < windowWidth.value; i += 1) {
        if (i % 50 === 0) {
          xScale.value.push({ id: i })
        }
      }
      for (let i = 0; i < windowHeight.value; i += 1) {
        if (i % 50 === 0) {
          yScale.value.push({ id: i })
        }
      }
    } // 计算刻度
function  newLevelLine() {
      isDrag = true
      dragFlag = 'x'
    } // 生成一个水平参考线
function  newVerticalLine() {
      isDrag = true
      dragFlag = 'y'
    } // 生成一个垂直参考线
function  dottedLineMove($event) {
      switch (dragFlag) {
        case 'x':
          if (isDrag) {
            verticalDottedTop.value = $event.pageY - topSpacing
          }
          break
        case 'y':
          if (isDrag) {
            levelDottedLeft.value = $event.pageX - leftSpacing
          }
          break
        case 'l':
          if (isDrag) {
            verticalDottedTop.value = $event.pageY - topSpacing
          }
          break
        case 'v':
          if (isDrag) {
            levelDottedLeft.value = $event.pageX - leftSpacing
          }
          break
        default:
          break
      }
    } // 虚线移动
function  dottedLineUp($event) {
      if (isDrag) {
        isDrag = false
        switch (dragFlag) {
          case 'x':
            levelLineList.value.push(
              {
                id: 'levelLine' + levelLineList.value.length + 1,
                title: $event.pageY + 1 - topSpacing -18 + 'px',
                top: $event.pageY - topSpacing + 1
              }
            )
            break
          case 'y':
            verticalLineList.value.push(
              {
                id: 'verticalLine' + verticalLineList.value.length + 1,
                title: $event.pageX + 1 - leftSpacing -18 + 'px',
                left: $event.pageX - leftSpacing + 1
              }
            )
            break
          case 'l':
            if ($event.pageY - topSpacing < rulerHeight) {
              let Index, id
              levelLineList.value.forEach((item, index) => {
                if (item.id === dragLineId) {
                  Index = index
                  id = item.id
                }
              })
              levelLineList.value.splice(Index, 1, {
                id: id,
                title: -600 + 'px',
                top: -600
              })
            } else {
              let Index, id
              levelLineList.value.forEach((item, index) => {
                if (item.id === dragLineId) {
                  Index = index
                  id = item.id
                }
              })
              levelLineList.value.splice(Index, 1, {
                id: id,
                title: $event.pageY + 1 - topSpacing -18 + 'px',
                top: $event.pageY - topSpacing + 1
              })
            }
            break
          case 'v':
            if ($event.pageX - leftSpacing < rulerWidth) {
              let Index, id
              verticalLineList.value.forEach((item, index) => {
                if (item.id === dragLineId) {
                  Index = index
                  id = item.id
                }
              })
              verticalLineList.value.splice(Index, 1, {
                id: id,
                title: -600 + 'px',
                left: -600
              })
            } else {
              let Index, id
              verticalLineList.value.forEach((item, index) => {
                if (item.id === dragLineId) {
                  Index = index
                  id = item.id
                }
              })
              verticalLineList.value.splice(Index, 1, {
                id: id,
                title: $event.pageX + 2 - leftSpacing - 18 + 'px',
                left: $event.pageX - leftSpacing + 1
              })
            }
            break
          default:
            break
        }
        verticalDottedTop.value = levelDottedLeft.value = -10
      }
    } // 虚线松开
function  levelDragRuler() {
      newLevelLine()
    } // 水平标尺处按下鼠标
function  verticalDragRuler() {
      newVerticalLine()
    } // 垂直标尺处按下鼠标
function  dragLevelLine(id) {
      isDrag = true
      dragFlag = 'l'
      dragLineId = id
    } // 水平线处按下鼠标
function  dragVerticalLine(id) {
      isDrag = true
      dragFlag = 'v'
      dragLineId = id
    } // 垂直线处按下鼠标
function   keyboard($event) {
      if (props.isHotKey) {
        switch ($event.keyCode) {
          case keyCode.r:
            rulerToggle.value =!rulerToggle.value
            break
        }
      }
    }// 键盘事件
function  quickGeneration(params) {
      if (params != []) {
        params.forEach(item => {
          switch (item.type) {
            case 'l':
              levelLineList.value.push({
                id: 'levelLine' + levelLineList.value.length + 1,
                title: item.site + 'px',
                top: item.site
              })
              break
            case 'v':
              verticalLineList.value.push({
                id: 'verticalLine' + verticalLineList.value.length + 1,
                title: item.site + 'px',
                left: item.site
              })
              break
            default:
              break
          }
        })
      }
    }

onMounted(()=>{
  //document.documentElement.addEventListener('mousemove', this.dottedLineMove, true)
    document.addEventListener('mousemove', dottedLineMove, true)
    document.addEventListener('mouseup', dottedLineUp, true)
    document.addEventListener('keyup', keyboard, true)

    quickGeneration(props.presetLine) // 生成预置参考线
    init()
    window.onresize = ()=> { // 如果直接使用this,this指向的不是vue实例
      xScale.value = []
      yScale.value = []
      init()
    }
})
onBeforeUnmount(()=>{
    document.removeEventListener('mousemove', dottedLineMove, true)
    document.removeEventListener('mouseup', dottedLineUp, true)
    document.removeEventListener('keyup', keyboard, true)
})

</script>

<style scoped>
  .ScaleBox {
    left: 0;
    top: 0;
    z-index: 999;
    overflow: hidden;
    user-select: none;
  }

  .ScaleRuler_h, .ScaleRuler_v, .RefLine_v, .RefLine_h, .RefDot_h, .RefDot_v {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    z-index: 999;
  }

  .ScaleRuler_h {
    width: 100%;
    height: 18px;
    left:18px;
    opacity: 0.6;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAASCAMAAAAuTX21AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAlQTFRFMzMzAAAA////BqjYlAAAACNJREFUeNpiYCAdMDKRCka1jGoBA2JZZGshiaCXFpIBQIABAAplBkCmQpujAAAAAElFTkSuQmCC) repeat-x;/*./image/ruler_h.png*/
  }

  .ScaleRuler_v {
    width: 18px;
    height: 100%;
    top:18px;
    opacity: 0.6;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAyCAMAAABmvHtTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAlQTFRFMzMzAAAA////BqjYlAAAACBJREFUeNpiYGBEBwwMTGiAakI0NX7U9aOuHyGuBwgwAH6bBkAR6jkzAAAAAElFTkSuQmCC) repeat-y; /*./image/ruler_v.png*/
  }

  .ScaleRuler_v .n, .ScaleRuler_h .n {
    position: absolute;
    font: 10px/1 Arial, sans-serif;
    color: #333;
    cursor: default;
  }

  .ScaleRuler_v .n {
    width: 8px;
    left: 3px;
    word-wrap: break-word;
  }

  .ScaleRuler_h .n {
    top: 1px;
  }

  .RefLine_v, .RefLine_h, .RefDot_h, .RefDot_v {
    z-index: 998;
  }

  .RefLine_h {
    width: 100%;
    height: 3px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFSv//AAAAH8VRuAAAAA5JREFUeNpiYIACgAADAAAJAAE0lmO3AAAAAElFTkSuQmCC) repeat-x left center;/*./image/line_h.png*/
    cursor: n-resize; /*url(./image/cur_move_h.cur), move*/
  }

  .RefLine_v {
    width: 3px;
    height: 100%;
    _height: 9999px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAICAMAAAAPxGVzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFSv//AAAAH8VRuAAAAA5JREFUeNpiYEAFAAEGAAAQAAGePof9AAAAAElFTkSuQmCC) repeat-y center top;/*./image/line_v.png*/
    cursor: w-resize;/*url(./image/cur_move_v.cur), move*/
  }

  .RefDot_h {
    width: 100%;
    height: 3px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFf39/////F3PnHQAAAAJ0Uk5T/wDltzBKAAAAEElEQVR42mJgYGRgZAQIMAAADQAExkizYQAAAABJRU5ErkJggg==) repeat-x left 1px;/*./image/line_dot.png*/
    cursor:  n-resize;/*url(./image/cur_move_h.cur), move*/
    top: -10px;
  }

  .RefDot_v {
    width: 3px;
    height: 100%;
    _height: 9999px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAMAAABFaP0WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFf39/////F3PnHQAAAAJ0Uk5T/wDltzBKAAAAEElEQVR42mJgYGRgZAQIMAAADQAExkizYQAAAABJRU5ErkJggg==) repeat-y 1px top;/*./image/line_dot.png*/
    cursor: w-resize;/*url(./image/cur_move_v.cur), move*/
    left: -10px;
  }
  #content {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: auto;
  }
</style>
